import React, { useState, useEffect } from 'react';
import CategoryLoadingIndicator from './CategoryLoadingIndicator';

interface ImagePreviewCardProps {
  preview: {
    name: string;
    size: string;
    preview?: string;
    isImage: boolean;
  };
  analysisResult?: {
    success: boolean;
    category?: string;
    description?: string;
    error?: string;
  };
  isAnalyzing: boolean;
  index: number;
}

const ImagePreviewCard: React.FC<ImagePreviewCardProps> = ({
  preview,
  analysisResult,
  isAnalyzing,
  index
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  // Stagger the image load animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsImageLoaded(true);
    }, index * 150);

    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div className="relative group">
      <div 
        className={`aspect-square bg-gray-100 rounded-lg overflow-hidden border border-gray-200 transition-all duration-800 ease-out ${
          isImageLoaded ? 'opacity-100 blur-0 scale-100' : 'opacity-30 blur-sm scale-95'
        }`}
      >
        {preview.preview ? (
          <img 
            src={preview.preview} 
            alt={preview.name} 
            className="w-full h-full object-cover"
            onLoad={() => setIsImageLoaded(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2z"></path>
            </svg>
          </div>
        )}
      </div>
      
      <div className="mt-2 text-xs text-gray-600 truncate">
        <p className="font-medium truncate">{preview.name}</p>
        <p className="text-gray-500">{preview.size}</p>
      </div>

      {/* Category and Description Loading/Result */}
      <CategoryLoadingIndicator
        isVisible={isAnalyzing || !!analysisResult}
        hasResult={!!analysisResult}
        category={analysisResult?.category}
        description={analysisResult?.description}
        error={analysisResult?.error}
      />
    </div>
  );
};

export default ImagePreviewCard;